import React, { useState, useEffect, useRef } from "react";
import Logo from "./img/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/action/authAction";
import { CiSearch } from "react-icons/ci";
import { PiPackageThin } from "react-icons/pi";
import { CiLogout, CiLogin } from "react-icons/ci";
import { CiMenuFries } from "react-icons/ci";
import { IoClose } from "react-icons/io5";
import { FaUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { storeRedirectUrl } from "../store/action/authAction";
import Swal from "sweetalert2";
import "../home/style.css";
import "./nav.css";

function Nav({
  toggleLogin,
  toggleCart,
  searchTerm,
  onSearchChange,
  onSearchSubmit,
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // mobile menu
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const cartItems = useSelector((state) => state.cart.cartItems);

  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);

  const cartCount = cartItems.reduce(
    (total, item) => total + (item.quantity || 1),
    0
  );

  const dispatch = useDispatch();

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to Logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Logout!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(logout());
      }
    });
    setIsDropdownOpen(false);
  };

  const closeDrop = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        closeDrop.current &&
        !closeDrop.current.contains(event.target) &&
        !event.target.closest(".Avatar-dropdown-menu") // Ensure clicks inside the dropdown don't close it
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/");
  };

  const handleSocialLogin = () => {
    // Store the path only, not full URL
    const currentPath = window.location.pathname + window.location.search;
    dispatch(storeRedirectUrl(currentPath));
    toggleLogin(true);

    console.log("this is my redirect url", currentPath);
  };

  return (
    <div className="nav-container">
      <section id="header">
        <img
          src={Logo}
          className="logo"
          alt="logo"
          onClick={handleLogoClick}
          style={{ cursor: "pointer" }}
        />

        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchSubmit();
          }}
          className="search-container  mobile-search"
        >
          <input
            type="text"
            id="searchInput"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search for a product..."
          />
          <button id="search-button" type="submit">
            <i className="fa fa-search">
              <CiSearch />
            </i>
          </button>
        </form>
        <div>
          <div className="mobile-icons">
            <div className="mobile-icons-center">
              {isDropdownOpen && (
                <div className="Avatar-dropdown-menu" ref={closeDrop}>
                  {!isAuthenticated ? (
                    <span className="logout" onClick={handleSocialLogin}>
                      <CiLogin className="avatar-icons" /> login
                    </span>
                  ) : (
                    <>
                      <Link to="/OrdersTable">
                        <span className="logout">
                          <PiPackageThin size="20" className="avatar-icons" />{" "}
                          My Order
                        </span>
                      </Link>
                      <span className="logout" onClick={handleLogout}>
                        <CiLogout className="avatar-icons" /> Logout
                      </span>
                    </>
                  )}
                </div>
              )}
              <div
                className="avatar user-profile nav-icons"
                onClick={toggleDropdown}
              >
                {user ? (
                  user.user_metadata?.avatar_url ||
                  user.user_metadata?.picture ||
                  user.identities?.find((i) =>
                    ["google", "facebook"].includes(i.provider)
                  )?.identity_data?.avatar_url ? (
                    <img
                      src={
                        user.user_metadata?.avatar_url ||
                        user.user_metadata?.picture ||
                        user.identities.find((i) =>
                          ["google", "facebook"].includes(i.provider)
                        )?.identity_data?.avatar_url
                      }
                      alt="Profile"
                      className="profile-avatar"
                    />
                  ) : (
                    <FaUser size="30" />
                  )
                ) : (
                  <FaUser size="30" />
                )}
              </div>
              <div className="icon-cart-nav">
                <svg
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 18 20"
                  onClick={toggleCart}
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0h8m-8 0-1-4m9 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-9-4h10l2-7H3m2 7L3 4m0 0-.792-3H1"
                  />
                </svg>
                <span>{cartCount}</span>
              </div>

              <>
                {/* Mobile Menu Trigger */}
                <CiMenuFries
                  onClick={toggleMobileMenu}
                  className="menu-icon"
                  size={30}
                />

                {/* Mobile Menu Overlay */}
                {isMobileMenuOpen && (
                  <div
                    className="mobile-menu-overlay"
                    onClick={toggleMobileMenu}
                  ></div>
                )}

                {/* Mobile Menu Slider */}
                <div
                  className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}
                >
                  <div className="mobile-menu-header">
                    <IoClose
                      className="close-icon"
                      onClick={toggleMobileMenu}
                      size={24}
                    />
                  </div>

                  {/* Search Container */}
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      onSearchSubmit();
                      toggleMobileMenu();
                      onSearchChange("");
                    }}
                    className="mobile-search-container"
                  >
                    <button type="submit" className="search-icon-btn">
                      <CiSearch className="search-icon" size={24} />
                    </button>
                    <input
                      type="text"
                      placeholder="Search..."
                      className="mobile-search-input"
                      value={searchTerm}
                      onChange={(e) => onSearchChange(e.target.value)}
                    />
                  </form>

                  {/* Menu Items */}
                  <nav className="mobile-nav-items">
                    <Link to="/" onClick={toggleMobileMenu}>
                      Home
                    </Link>
                    <Link to="/About" onClick={toggleMobileMenu}>
                      About Us
                    </Link>
                    <Link to="/Contact" onClick={toggleMobileMenu}>
                      Contact
                    </Link>
                  </nav>
                </div>
              </>
            </div>
          </div>
          <ul id="navbar">
            <Link className="mobile-nav" to="/">
              {" "}
              <li className="active">Home</li>
            </Link>

            <Link className="mobile-nav" to="/Contact">
              {" "}
              <li>Contact</li>
            </Link>
            <Link className="mobile-nav" to="/About">
              <li>About Us</li>
            </Link>

            {isDropdownOpen && (
              <div className="Avatar-dropdown-menu" ref={closeDrop}>
                {!isAuthenticated ? (
                  <span className="logout" onClick={toggleLogin}>
                    <CiLogin className="avatar-icons" /> login
                  </span>
                ) : (
                  <>
                    <Link to="/OrdersTable">
                      <span className="logout">
                        <PiPackageThin size="20" className="avatar-icons" /> My
                        Order
                      </span>
                    </Link>
                    <span className="logout" onClick={handleLogout}>
                      <CiLogout className="avatar-icons" /> Logout
                    </span>
                  </>
                )}
              </div>
            )}
            <div
              className="avatar user-profile nav-icons"
              onClick={toggleDropdown}
            >
              {user ? (
                user.user_metadata?.avatar_url ||
                user.user_metadata?.picture ||
                user.identities?.find((i) =>
                  ["google", "facebook"].includes(i.provider)
                )?.identity_data?.avatar_url ? (
                  <img
                    src={
                      user.user_metadata?.avatar_url ||
                      user.user_metadata?.picture ||
                      user.identities.find((i) =>
                        ["google", "facebook"].includes(i.provider)
                      )?.identity_data?.avatar_url
                    }
                    alt="Profile"
                    className="profile-avatar"
                  />
                ) : (
                  <FaUser size="30" />
                )
              ) : (
                <FaUser size="30" />
              )}
            </div>
            <div className="icon-cart">
              <svg
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 18 20"
                onClick={toggleCart}
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm0 0h8m-8 0-1-4m9 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-9-4h10l2-7H3m2 7L3 4m0 0-.792-3H1"
                />
              </svg>
              <span>{cartCount}</span>
            </div>
            <Link href="#" id="close">
              <i className="fa fa-times"></i>
            </Link>
          </ul>
        </div>
        <div id="mobile">
          <a href="cart.html">
            <i className="fa fa-bag-shopping"></i>
          </a>
          <i id="bar" className="fa fa-outdent"></i>
        </div>
      </section>
    </div>
  );
}

export default Nav;
